import { state } from './state';
import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

export { DataMapper, DbToObject, PageInfo, PageManager } from './state';

export const pageManager = {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
